import React from "react";
import MUITypography from "@mui/material/Typography";
import MUIContainer from "@mui/material/Container";

export default class EmptyState extends React.Component {
  /**
   * Render up to two lines of text for the empty state.
   */
  render() {
    return (
      <MUIContainer
        maxWidth="md"
        sx={{ textAlign: "center", paddingTop: 2, paddingBottom: 2 }}
      >
        {this.props.line1 && (
          <MUITypography
            variant="body1"
            color="textPrimary"
            sx={{
              display: "block",
            }}
          >
            {this.props.line1}
          </MUITypography>
        )}
        {this.props.line2 && (
          <MUITypography
            variant="body2"
            color="textSecondary"
            sx={{
              display: "block",
            }}
          >
            {this.props.line2}
          </MUITypography>
        )}
      </MUIContainer>
    );
  }
}
